module.exports = __webpack_public_path__ + "static/img/pic_logon_step1@2x.079b307.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contactUs/creatorProcess/pic_logon_step1@2x.png
// module id = m2cl
// module chunks = 0